(() => {
  if (window.KrosperUltimatePremiumLoaded) return;
  window.KrosperUltimatePremiumLoaded = true;
  const states = new WeakMap();
  const enhance = root => {
    if (!root || states.has(root) || !root.classList.contains('uv-enhanced')) return;
    const audio = root.querySelector('[data-audio]');
    if (!audio || !root.trackLinks?.length) return;
    const life = new AbortController();
    const buttons = [...root.querySelectorAll('[data-premium-demo]')];
    const now = root.querySelector('[data-premium-now]');
    const sync = () => {
      const playing = !audio.paused && !audio.ended;
      root.classList.toggle('is-listening', playing);
      buttons.forEach(button => {
        const track = root.trackLinks[root.audioIndex];
        button.setAttribute('aria-pressed', String(playing && track?.dataset.product === button.dataset.premiumDemo));
      });
      if (now) now.textContent = root.audioStarted ? root.trackLinks[root.audioIndex]?.dataset.title || '' : '';
    };
    buttons.forEach(button => {
      const index = root.trackLinks.findIndex(track => track.dataset.product === button.dataset.premiumDemo);
      if (index < 0) return;
      button.hidden = false;
      button.addEventListener('click', () => {
        if (!audio.paused && root.trackLinks[root.audioIndex]?.dataset.product === button.dataset.premiumDemo) audio.pause();
        else root.chooseTrack(index, true);
        sync();
      }, {signal: life.signal});
    });
    ['play', 'pause', 'ended', 'playing', 'error', 'loadedmetadata'].forEach(event => audio.addEventListener(event, sync, {signal: life.signal}));
    const observer = new MutationObserver(() => {
      if (!root.isConnected) {
        life.abort();
        observer.disconnect();
        states.delete(root);
      }
    });
    observer.observe(root.parentNode, {childList: true});
    const decision = root.querySelector('.uv-decision');
    const offerObserver = decision && 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
      root.classList.toggle('uv-offer-in-view', entries.some(entry => entry.isIntersecting));
    }, {threshold: .05}) : null;
    if (offerObserver) offerObserver.observe(decision);
    states.set(root, {life, observer, offerObserver});
    sync();
  };
  const boot = scope => scope.querySelectorAll('krosper-ultimate-v12.uv14').forEach(enhance);
  customElements.whenDefined('krosper-ultimate-v12').then(() => boot(document));
  document.addEventListener('shopify:section:load', event => boot(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('krosper-ultimate-v12.uv14').forEach(root => {
      const state = states.get(root);
      state?.life.abort();
      state?.observer.disconnect();
      state?.offerObserver?.disconnect();
      states.delete(root);
    });
  });
})();
